import React, { useContext, useEffect, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify'
import styled from 'styled-components'
import ProductCard from '../components/ProductCard'
import { db, useAuth } from '../firebase-config'
import { collection, doc, getDocs, query, setDoc, where } from 'firebase/firestore'
import { Oval } from 'react-loader-spinner'
import { ProductDetailContext } from '../context/ProductDetailsProvider'

const LikesScreen =  () => {
    const [loader, setLoader] = useState(false)
    const [productListArr, setProductListArr] = useState([])
    const [isLiked, setIsLiked] = useState(null)
    const currentUser = useAuth()
    const productContext = useContext(ProductDetailContext)
  

    const handleAddToWishlist = async (e, item, index) => {
        e.stopPropagation()
        if(isLiked){
          setIsLiked(null)
        }else{
          setIsLiked(index)
          
        }
        toast.success("Added to wishlist")
        console.log(item)
        console.log(productListArr)
        let filteredWishlist = []
    
        if (item.wishlistedUser?.includes(currentUser.uid)) {
          let indexOfitem = item.wishlistedUser.findIndex(
            user => user === currentUser.uid
          )
          filteredWishlist = [...item.wishlistedUser]
          filteredWishlist.splice(indexOfitem, 1)
          console.log(filteredWishlist)
          
          try {
            await setDoc(
              doc(db, "products", item.id),
              {
                wishlistedUser: filteredWishlist,
              },
              { merge: true }
            )
            toast.success("Added to wishlist")
          } catch (error) {
            console.log(error)
          }
        } else {
          // let alreadyWishlistedUser = [...item.wishlistedUser]
          try {
            console.log('in else block')
            await setDoc(doc(db, "products", item.id),{
                wishlistedUser: [currentUser.uid],
              },{ merge: true })
            toast.success("Added to wishlist")
          } catch (error) {
            console.log(error)
          }
          
        }
      }


    const fetchLikedProducts = async () => {
        try {
            setLoader(true)
            const q = query(collection(db, "products"), where("wishlistedUser", "array-contains", currentUser.uid))
            const querySnapshot = await getDocs(q)
            setProductListArr(querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })))
            setLoader(false)
            console.log(productListArr)
          } catch (error) {
            setLoader(false)
            console.error(error)
          }
    }

    useEffect(() => {
        fetchLikedProducts()
        productContext.handleData({})
        productContext.handleDocId('')
        productContext.handleUser2Id('')
    }, [currentUser?.uid])
    

    
  return (
    <>
      <ToastContainer limit={1} autoClose={500} />
      <LikeWrapper>
          
          { loader?
                        <Oval color={"#fafafa"} secondaryColor={"#dc1d13"} width={"30px"} />
            :

            (
              productListArr?.length == 0?
              <span>No Products in Likes</span>
              :
              productListArr.map((item, index) => {
                return (
                  <ProductCard
                    key={index}
                    linkTo={`/productdetail/:${item.id}`}
                    productImage={item.productPhoto}
                    productPrice={item.productDetails?.originalPrice}
                    sellerName={""}
                    handleHeartIcon={e => handleAddToWishlist(e, item, index)}
                    isLiked={item.wishlistedUser?.includes(currentUser?.uid) || isLiked === index ? true: false}
                    productName={item.productDetails?.productName}
                    setWidth={"10rem"}
                    setHeight={"385px"}
                    imgHeight={"234px"}
                    imgWidth={"10rem"}
                  />
                )
              })
            )

          }
      </LikeWrapper>  
    </>
  )
}

export default LikesScreen


const LikeWrapper = styled.div`
    display: flex;
    flex-direction: row;
    background:  ${({ theme }) => theme.body};
    height: 100%;
    width: 100%;
    justify-content: space-evenly;
    flex-wrap: wrap;
    align-items: center;

    span {
      margin-top: 1rem;
    }
`


